import { Button } from '@edsn/pie-components';
import AddIcon from '@iconify/icons-material-symbols/add';
import { useEffect, useState } from 'react';
import type { SubmitHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Dialog } from '#pie/components/layout/dialog/Dialog';
import { useCreateContact } from '#pie/hooks/useCreateContact';
import type { CreateContactRequest } from '#pie/internal/api/pie-bff';
import { Icon } from '../icon/Icon';
import { ContactForm } from './ContactForm';

export const CreateContactModal = () => {
  const { t } = useTranslation('common');
  const [isOpen, setIsOpen] = useState(false);

  const { mutate, isPending } = useCreateContact({
    onSuccess: () => setIsOpen(false),
  });

  const onSubmit: SubmitHandler<CreateContactRequest> = (data) => {
    mutate({ data });
  };

  const [step, setStep] = useState(1);

  useEffect(() => {
    if (!isOpen) return;
    setStep(1);
  }, [isOpen]);

  const stepDescriptions: Record<number, string> = {
    1: t('cpr_management.contact_modal.step.personal_data'),
    2: t('cpr_management.contact_modal.step.contact_groups'),
  };

  return (
    <>
      <Button
        iconStart={<Icon icon={AddIcon} />}
        action="secondary"
        emphasis="bold"
        onClick={() => setIsOpen(true)}
      >
        {t('common.contactperson')}
      </Button>

      {isOpen && (
        <Dialog
          title={t('cpr_management.contact_modal.title.create')}
          size="md"
          open={isOpen}
          onOpenChange={setIsOpen}
          description={stepDescriptions[step]}
        >
          <ContactForm
            step={step}
            onBack={() => setStep(1)}
            onNext={() => setStep(2)}
            isLoading={isPending}
            onSubmit={onSubmit}
            submitText={t('cpr_management.contact_modal.button.create')}
          />
        </Dialog>
      )}
    </>
  );
};
